import { Button } from '@sortlist-frontend/design-system';
import { ArrowRight } from '@sortlist-frontend/design-system/icons';
import { useState } from 'react';

import type { GuideCta } from '../types';
import { ToggleItem } from './ToggleItem';

interface ExpertQuizProps {
  legend: string;
  items: readonly string[];
  countLabel: string;
  tiers: readonly { title: string; text: string }[];
  cta: GuideCta;
}

const tierFor = (count: number) => (count === 0 ? 0 : count <= 2 ? 1 : 2);

export const ExpertQuiz = (props: ExpertQuizProps) => {
  const { legend, items, countLabel, tiers, cta } = props;
  const [checked, setChecked] = useState<readonly boolean[]>(items.map(() => false));
  const count = checked.filter(Boolean).length;
  const tier = tiers[Math.min(tierFor(count), tiers.length - 1)];

  return (
    <div className="grid items-start gap-6 md:grid-cols-[1.4fr_1fr]">
      <fieldset className="space-y-3">
        <legend className="sr-only">{legend}</legend>
        {items.map((item, index) => (
          <ToggleItem
            key={item}
            checked={checked[index]}
            onChange={(value) => setChecked(checked.map((current, i) => (i === index ? value : current)))}>
            {item}
          </ToggleItem>
        ))}
      </fieldset>
      <div className="rounded-2xl border border-primary-200 bg-primary-50 p-5 md:sticky md:top-24" aria-live="polite">
        <p className="text-sm text-secondary-700">
          <span className="font-semibold text-secondary-950">{count}</span> {countLabel}
        </p>
        <p className="mt-1 text-xl font-bold text-secondary-950">{tier.title}</p>
        <p className="mt-2 text-sm leading-relaxed text-secondary-700">{tier.text}</p>
        <div className="mt-4">
          <Button as="a" href={cta.href} color="primary" variant="solid" size="md" endContent={<ArrowRight />}>
            {cta.label}
          </Button>
        </div>
      </div>
    </div>
  );
};
